export const remembrance = {
  id: "remembrance",
  name: "Remembrance",

  scene: {
    backgroundImage: null,
    baseColor: "#0c0606",
    radialGlow: "radial-gradient(ellipse at 50% 45%, rgba(150, 0, 0, 0.12) 0%, transparent 60%)",
    overlayTint: "rgba(10, 4, 4, 0.42)",
    vignette: 0.65,
    parallaxStrength: 0.3,
    particleType: "poppies",
  },

  glass: {
    bg: "rgba(20, 8, 8, 0.55)",
    blur: 14,
    border: "rgba(180, 40, 40, 0.22)",
    radius: 14,
  },

  glow: {
    edgeColor: "rgba(180, 40, 40, 0.40)",
    edgeStrength: 0.40,
    heroBoost: 0.4,
  },

  accent: {
    primary: "#c83030",
    secondary: "#8a2020",
  },

  numeric: {
    positive: "#22c55e",
    warning: "#f59e0b",
    danger: "#ef4444",
  },

  ai: {
    orbStyle: "poppy",
    orbGlow: "rgba(180,40,40,0.34)",
  },

  tokens: {
    "--tl-bg-0": "#0c0606",
    "--tl-bg-1": "#080404",
    "--tl-bg-2": "#040202",
    "--tl-text-0": "#f0d8d8",
    "--tl-text-1": "#d4b0b0",
    "--tl-text-muted": "#a07878",
    "--tl-accent-0": "#c83030",
    "--tl-accent-1": "#8a2020",
    "--tl-glass-bg": "rgba(20, 8, 8, 0.55)",
    "--tl-glass-border": "rgba(180, 40, 40, 0.22)",
    "--tl-glass-blur": "14px",
    "--tl-glass-shadow": "0 10px 30px rgba(0,0,0,0.50)",
    "--tl-glass-glow-color": "rgba(180,40,40,0.28)",
    "--tl-glow-edge-color": "rgba(180, 40, 40, 0.40)",
    "--tl-glow-edge-strength": "0.40",
    "--tl-glow-hero-boost": "0.4",
    "--tl-radius": "14px",
    "--tl-molten-wordmark-gradient": "none",
  },
};
